import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'BrandGuardianIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-guardian",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14 13h6"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4 12c0 -9.296 9.5 -9 9.5 -9c-2.808 0 -4.5 4.373 -4.5 9s1.763 8.976 4.572 8.976c0 .023 -9.572 1.092 -9.572 -8.976z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14.5 3c1.416 0 3.853 1.16 4.5 2v3.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M15 13v8s2.77 -.37 4 -2v-6"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M13.5 21h1.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M13.5 3h1"
    }, null), _createTextVNode(" ")]);
  }
};